// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/chart/v1/densetimeserieschart.proto (package chalk.chart.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ScalarValue } from "../../arrow/v1/arrow_pb";
import { file_chalk_arrow_v1_arrow } from "../../arrow/v1/arrow_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/chart/v1/densetimeserieschart.proto.
 */
export const file_chalk_chart_v1_densetimeserieschart: GenFile = /*@__PURE__*/
  fileDesc("CiljaGFsay9jaGFydC92MS9kZW5zZXRpbWVzZXJpZXNjaGFydC5wcm90bxIOY2hhbGsuY2hhcnQudjEiKgoKRGVuc2VQb2ludBISCgV2YWx1ZRgBIAEoAUgAiAEBQggKBl92YWx1ZSJgCghHcm91cFRhZxIRCglncm91cF9rZXkYASABKAkSKgoFdmFsdWUYAiABKAsyGy5jaGFsay5hcnJvdy52MS5TY2FsYXJWYWx1ZRIVCg12YWx1ZV9kaXNwbGF5GAMgASgJIogBCg9EZW5zZVRpbWVTZXJpZXMSKgoGcG9pbnRzGAEgAygLMhouY2hhbGsuY2hhcnQudjEuRGVuc2VQb2ludBINCgVsYWJlbBgCIAEoCRIMCgR1bml0GAMgASgJEiwKCmdyb3VwX3RhZ3MYBCADKAsyGC5jaGFsay5jaGFydC52MS5Hcm91cFRhZyK2AQoURGVuc2VUaW1lU2VyaWVzQ2hhcnQSDQoFdGl0bGUYASABKAkSLwoGc2VyaWVzGAIgAygLMh8uY2hhbGsuY2hhcnQudjEuRGVuc2VUaW1lU2VyaWVzEiwKCHhfc2VyaWVzGAMgAygLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIwCg13aW5kb3dfcGVyaW9kGAQgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uQhRaEnNlcnZlci92MTtzZXJ2ZXJ2MWIGcHJvdG8z", [file_chalk_arrow_v1_arrow, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.chart.v1.DensePoint
 */
export type DensePoint = Message<"chalk.chart.v1.DensePoint"> & {
  /**
   * wrapped in a Point to allow for optional (empty space in time series)
   *
   * @generated from field: optional double value = 1;
   */
  value?: number;
};

/**
 * Describes the message chalk.chart.v1.DensePoint.
 * Use `create(DensePointSchema)` to create a new message.
 */
export const DensePointSchema: GenMessage<DensePoint> = /*@__PURE__*/
  messageDesc(file_chalk_chart_v1_densetimeserieschart, 0);

/**
 * If this series was created as part of a group-by(s)
 * This stores extra information about which ones and what value it pertains to
 *
 * @generated from message chalk.chart.v1.GroupTag
 */
export type GroupTag = Message<"chalk.chart.v1.GroupTag"> & {
  /**
   * @generated from field: string group_key = 1;
   */
  groupKey: string;

  /**
   * Raw backend value. Differs between metrics backends for mapped group kinds
   * (TimescaleDB stores enum codes where VictoriaMetrics stores names).
   *
   * @generated from field: chalk.arrow.v1.ScalarValue value = 2;
   */
  value?: ScalarValue;

  /**
   * Display string for the value, stable across backends. Matches the value
   * persisted in IncidentGroup so a series can be matched to its incident.
   *
   * @generated from field: string value_display = 3;
   */
  valueDisplay: string;
};

/**
 * Describes the message chalk.chart.v1.GroupTag.
 * Use `create(GroupTagSchema)` to create a new message.
 */
export const GroupTagSchema: GenMessage<GroupTag> = /*@__PURE__*/
  messageDesc(file_chalk_chart_v1_densetimeserieschart, 1);

/**
 * @generated from message chalk.chart.v1.DenseTimeSeries
 */
export type DenseTimeSeries = Message<"chalk.chart.v1.DenseTimeSeries"> & {
  /**
   * @generated from field: repeated chalk.chart.v1.DensePoint points = 1;
   */
  points: DensePoint[];

  /**
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * @generated from field: string unit = 3;
   */
  unit: string;

  /**
   * @generated from field: repeated chalk.chart.v1.GroupTag group_tags = 4;
   */
  groupTags: GroupTag[];
};

/**
 * Describes the message chalk.chart.v1.DenseTimeSeries.
 * Use `create(DenseTimeSeriesSchema)` to create a new message.
 */
export const DenseTimeSeriesSchema: GenMessage<DenseTimeSeries> = /*@__PURE__*/
  messageDesc(file_chalk_chart_v1_densetimeserieschart, 2);

/**
 * *
 * A representation of a densely encoded chart, suitable for time series where the series
 * have mostly non-null values.
 * Consider implementing a sparse chart if not every series has data at every tick
 *
 * @generated from message chalk.chart.v1.DenseTimeSeriesChart
 */
export type DenseTimeSeriesChart = Message<"chalk.chart.v1.DenseTimeSeriesChart"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: repeated chalk.chart.v1.DenseTimeSeries series = 2;
   */
  series: DenseTimeSeries[];

  /**
   * @generated from field: repeated google.protobuf.Timestamp x_series = 3;
   */
  xSeries: Timestamp[];

  /**
   * @generated from field: google.protobuf.Duration window_period = 4;
   */
  windowPeriod?: Duration;
};

/**
 * Describes the message chalk.chart.v1.DenseTimeSeriesChart.
 * Use `create(DenseTimeSeriesChartSchema)` to create a new message.
 */
export const DenseTimeSeriesChartSchema: GenMessage<DenseTimeSeriesChart> = /*@__PURE__*/
  messageDesc(file_chalk_chart_v1_densetimeserieschart, 3);

